const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

class SettingsService {
  async getEmailSettings() {
    const token = localStorage.getItem('access_token');
    const response = await fetch(`${API_BASE_URL}/settings/email`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch email settings');
    }

    return response.json();
  }

  async updateEmailSettings(settings) {
    const token = localStorage.getItem('access_token');
    const response = await fetch(`${API_BASE_URL}/settings/email`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(settings)
    });

    if (!response.ok) {
      throw new Error('Failed to update email settings');
    }

    return response.json();
  }

  async testEmail(testEmail) {
    const token = localStorage.getItem('access_token');
    const response = await fetch(`${API_BASE_URL}/settings/email/test?test_email=${encodeURIComponent(testEmail)}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.detail || 'Failed to send test email');
    }

    return response.json();
  }
}

const settingsService = new SettingsService();
export default settingsService;
